export default __webpack_public_path__ + "static/media/16@1x.a21477da.png";